import { OverridableStringUnion } from '@mui/types';
import { ChipPropsColorOverrides } from '@mui/material/Chip/Chip';

const STATUS_ICON_MAP: { [key: string]: string } = {
  Pending: '',
  Approved: 'gg:check-o',
  Declined: 'material-symbols:cancel-outline',
};

const STATUS_ICON_COLOR_MAP: { [key: string]: OverridableStringUnion<
'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
ChipPropsColorOverrides
>; } = {
  Pending: 'warning',
  Approved: 'success',
  Declined: 'error',
};

const STATUS_FILTER_MAP: { [key: number]: string } = {
  1: 'Approved',
  2: 'Declined',
  3: 'Pending',
};

export {
  STATUS_ICON_MAP,
  STATUS_ICON_COLOR_MAP,
  STATUS_FILTER_MAP,
};
